import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import FJUtil from '../../../util/FJUtil';
import styles from './FJHorizontalScroller.module.less';
import classNames from 'classnames';

const FJHorizontalScroller = (
    { className, onScroll, onMouseWheel, showScrollBar = false, style = {}, children, dependArr = [], ...props },
    ref,
) => {
    const scrollerRef = useRef();

    useImperativeHandle(ref, () => {
        return {
            scrollToLeft: (left, behavior = 'auto') => {
                scrollerRef.current.scroll({ left, behavior });
            },
            getScroller: () => scrollerRef.current,
        };
    });

    useEffect(() => {
        const scroll = e => {
            if (onScroll) {
                onScroll(e);
            }
        };
        const wheel = e => {
            const scroller = scrollerRef.current;
            const left = scroller.scrollLeft + e.deltaY;
            scroller.scroll({ left, behavior: 'auto' });
            if (onMouseWheel) onMouseWheel(e);
        };
        scrollerRef.current.addEventListener('scroll', scroll);
        scrollerRef.current.addEventListener('wheel', wheel);
        return () => {
            if (scrollerRef.current) {
                scrollerRef.current.removeEventListener('scroll', scroll);
                scrollerRef.current.removeEventListener('wheel', wheel);
            }
        };
    }, [...dependArr]);

    return (
        <div
            ref={scrollerRef}
            className={classNames(styles.scroller_horizontal, className)}
            {...props}
            style={{
                ...style,
                scrollbarWidth: showScrollBar ? (FJUtil.getBrowser() === 'FF' ? 'thin' : 'auto') : 'none',
            }}
        >
            {children}
        </div>
    );
};

export default forwardRef(FJHorizontalScroller);
